module.exports = __webpack_public_path__ + "static/img/r_009.d1dc528.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_009.jpg
// module id = kHWq
// module chunks = 1